import { UsersTable } from "@/admin/users/UsersTable.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_dual/users")({
    component: UsersTable,
});
